"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ManagementToolbar = void 0;
var _mui = require("@ori-ui/mui");
var _useTranslations = require("../../../../hooks/useTranslations");
var _DeleteButton = require("../DeleteButton/DeleteButton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ManagementToolbar = ()=>{
    const { translations } = (0, _useTranslations.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                variant: "h4",
                component: "h4",
                children: translations.yourList
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeleteButton.DeleteButton, {})
        ]
    });
};
exports.ManagementToolbar = ManagementToolbar;
